export const environment = {
  production: true,
  apiUrl: 'https://sircles.sorintdev.it/api',
  env: 'prod',
  keycloak: {
    clientId: 'sircles',
    realm: 'sorinttest',
    url: 'https://access.sorintdev.it/'
  },
  savatarUrl: 'https://savatar.sorint.it/avatar',
  sisUrl: 'https://sis.sorintdev.it/api/v3/contact-search',
  contractUrl: "https://sis.sorintdev.it/contract",
  sentry: {
    tracesSampleRate: 0.001,
    replaysSessionSampleRate: 0.001,
    replaysOnErrorSampleRate: 0.001,
    enabled: false,
    dsn: "https://832a90a17ff74f0faa35f26cb89567bb@o1384609.ingest.sentry.io/4505550408384512",
    tracePropagationTargets: ['/*localhost*/', '/*sorint*/'],
    environment: "local"
  },
  matomo: {
    config: {
      trackerUrl: 'https://matomo.sorintdev.it/',
      siteId: 4,
      disabled: false
    }
  }
};
